<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <div class="cs-form-intro-medium pt-6 pb-3">
          {{ $t('verify.title') }}
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="px-3 pt-0 pb-3">
        <div class="text-h5 secondary--text pb-4">
          {{ $t('verify.titleVehicle') }}
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="8" class="px-3 pt-1 pb-2">
        <v-text-field outlined v-model.trim="csData.vehicle" :label="this.$t('verify.vehicle')"
          :error-messages="vehicleErrors" @input="$v.csData.vehicle.$touch()"
          @blur="$v.csData.vehicle.$touch()"></v-text-field>
      </v-col>

      <v-col cols="12" md="4" class="px-3 pt-1 pb-2">
        <v-text-field outlined v-model.trim="csData.plateNumber" :label="this.$t('verify.plateNumber')"
          :error-messages="plateNumberErrors" @input="$v.csData.plateNumber.$touch()"
          @blur="$v.csData.plateNumber.$touch()"></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6" class="px-3 pt-1 pb-2">
        <v-select outlined :items="countries" item-text="value" item-value="key" v-model="csData.registrationCountry"
          menu-props="auto" single-line :label="this.$t('verify.registrationCountry')"
          :error-messages="registrationCountryErrors" @input="$v.csData.registrationCountry.$touch()"
          @blur="$v.csData.registrationCountry.$touch()"></v-select>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="px-3 pt-3 pb-3">
        <div class="text-h5 secondary--text pb-4">
          {{ $t('verify.titleInsuranceComp') }}
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6" class="px-3 pt-1 pb-2">
        <v-textarea outlined v-model.trim="csData.insCompAddress" :label="this.$t('verify.insuranceNameAndAddress')"
          :error-messages="insuranceNameAndAddressErrors" @input="$v.csData.insCompAddress.$touch()"
          @blur="$v.csData.insCompAddress.$touch()"></v-textarea>
      </v-col>

      <v-col cols="12" md="6" class="px-3 pt-1 pb-2">
        <v-row>
          <v-col cols="12" class="px-3 pt-3 pb-0">
            <v-select outlined :items="countries" item-text="value" item-value="key" v-model="csData.insuranceCountry"
              auto single-line :label="this.$t('verify.insuranceCountry')" :error-messages="insuranceCountryErrors"
              @input="$v.csData.insuranceCountry.$touch()" @blur="$v.csData.insuranceCountry.$touch()"></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="px-3 pt-0 pb-0">
            <v-text-field outlined v-model.trim="csData.insCompPhoneNbr"
              :label="this.$t('verify.phone')"></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6" class="px-3 pt-1 pb-0">
        <v-text-field outlined v-model.trim="csData.contractNumber" :label="this.$t('verify.contractNumber')"
          :error-messages="contractNumberErrors" @input="$v.csData.contractNumber.$touch()"
          @blur="$v.csData.contractNumber.$touch()"></v-text-field>
      </v-col>

      <!--       <v-col
        cols="12"
        md="6"
        class="px-3 pt-1 pb-0"
        v-if="csData.insComp === 'ASSU2000'"
      >
        <v-text-field
          outlined
          v-model.trim="csData.greenCardNumber"
          label="N° de carte verte"
        ></v-text-field>
      </v-col>

      <v-col
        cols="12"
        md="12"
        class="px-3 pt-1 pb-2"
        v-if="csData.insComp === 'ASSU2000'"
      >
        Attestation d’assurance ou carte verte valable
      </v-col>

      <v-col
        cols="1"
        md="1"
        class="px-3 pt-3 pb-2 pl-3"
        v-if="csData.insComp === 'ASSU2000'"
      >
        Du :
      </v-col>

      <v-col
        cols="4"
        md="4"
        class="px-3 pt-1 pb-0"
        v-if="csData.insComp === 'ASSU2000'"
      >
        <v-text-field
          outlined
          dense
          v-model.trim="csData.validityDateStart"
        ></v-text-field>
      </v-col>

      <v-col
        cols="1"
        md="1"
        class="px-3 pt-3 pb-2"
        v-if="csData.insComp === 'ASSU2000'"
      >
        <v-spacer></v-spacer>
      </v-col>

      <v-col
        cols="1"
        md="1"
        class="px-3 pt-3 pb-2 pl-0 pl-4"
        v-if="csData.insComp === 'ASSU2000'"
      >
        au :
      </v-col>

      <v-col
        cols="4"
        md="4"
        class="px-3 pt-1 pb-0"
        v-if="csData.insComp === 'ASSU2000'"
      >
        <v-text-field
          outlined
          dense
          v-model.trim="csData.validityDateEnd"
        ></v-text-field>
      </v-col> -->
    </v-row>

    <v-row v-if="!a2User">
      <v-col cols="12" md="8" class="px-3 pt-4 pb-0">{{
            $t('verify.propertyDamage')
          }}</v-col>

      <v-col cols="12" md="4" class="px-3 pt-0 pb-2">
        <v-radio-group v-model="csData.propertyDamage" row>
          <v-radio :label="this.$t('verify.propertyDamageTypes.yes')" value="1" color="primary"></v-radio>
          <v-radio :label="this.$t('verify.propertyDamageTypes.no')" value="0" color="primary"></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="px-3 pt-3 pb-3">
        <div class="text-h5 secondary--text pb-4">
          {{ $t('verify.titleInsuranceSubscriber') }}
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6" class="px-3 pt-1 pb-2">
        <v-textarea outlined v-model.trim="csData.insTaker" :label="this.$t('verify.subscriberNameAndAddress')"
          :error-messages="insTakerErrors" @input="$v.csData.insTaker.$touch()"
          @blur="$v.csData.insTaker.$touch()"></v-textarea>
      </v-col>

      <v-col cols="12" md="6" class="px-3 pt-1 pb-2">
        <v-row>
          <v-col cols="12" class="px-3 pt-3 pb-0">
            <v-select outlined :items="countries" item-text="value" item-value="key" v-model="csData.subscriberCountry"
              auto single-line :label="this.$t('verify.subscriberCountry')" :error-messages="subscriberCountryErrors"
              @input="$v.csData.subscriberCountry.$touch()" @blur="$v.csData.subscriberCountry.$touch()"></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="px-3 pt-0 pb-0">
            <v-text-field outlined v-model.trim="csData.subscriberPhone"
              :label="this.$t('verify.phone')"></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="px-3 pt-3 pb-3">
        <div class="text-h5 secondary--text pb-3">
          {{ $t('verify.titleDriver') }}
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6" class="px-3 pt-1 pb-2" v-if="csData.insComp == 'ETHIAS' || showDriverNameField">
        <v-text-field outlined v-model.trim="csData.driverName" :label="this.$t('verify.driverName')"></v-text-field>
      </v-col>

      <v-col cols="12" md="6" class="px-3 pt-1 pb-2">
        <v-text-field outlined v-model.trim="csData.birthDate" :label="this.$t('verify.birthDate')" v-mask="dateMask"
          :hint="$t('verify.dateHint')"></v-text-field>
      </v-col>

      <v-col cols="12" md="6" class="px-3 pt-1 pb-2">
        <v-text-field outlined v-model.trim="csData.drivingLicenceType" :label="this.$t('verify.drivinglicenceType')"
          :hint="$t('verify.drivinglicenceTypeHint')"></v-text-field>
      </v-col>

      <v-col cols="12" md="6" class="px-3 pt-1 pb-2">
        <v-text-field outlined v-model.trim="csData.driverPhoneNbr" :label="this.$t('verify.phone')"></v-text-field>
      </v-col>

      <v-col cols="12" md="6" class="px-3 pt-1 pb-2" v-if="a2User">
        <v-text-field outlined v-model.trim="csData.drivingLicenceNbr" label="N° de permis de conduire"></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="px-1 pt-3 text-xs-left">
        <v-btn class="primary" @click="generateCS">{{
            $t('verify.button.generateCrashSticker')
          }}</v-btn>
      </v-col>
    </v-row>

    <v-row v-if="isGeneratingCS == true">
      <v-col cols="12" class="px-1 pt-5">
        <v-progress-linear indeterminate rounded height="7" color="primary"></v-progress-linear>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="490">
      <v-card>
        <v-card-title class="display-1 pb-7">{{
            $t('verify.error.emptyAccount.title')
          }}</v-card-title>
        <v-card-text class="subtitle-1">{{
              $t('verify.error.emptyAccount.text')
            }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="goToOrder">{{
            $t('verify.error.emptyAccount.button')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mask } from 'vue-the-mask';
import { required } from 'vuelidate/lib/validators';
const fb = require('../firebaseConfig.js');
export default {
  directives: {
    mask,
  },
  data() {
    return {
      csData: {
        vehicle: '',
        plateNumber: '',
        registrationCountry: '',
        insComp: '',
        insCompAddress: '',
        insuranceCountry: '',
        insCompPhoneNbr: '',
        contractNumber: '',
        greenCardNumber: '',
        propertyDamage: '1',
        validityDateStart: '',
        validityDateEnd: '',

        insTaker: '',
        subscriberPhone: '',
        subscriberCountry: '',

        driverName: '',
        drivingLicenceType: '',
        drivingLicenceNbr: '',
        birthDate: '',
        driverPhoneNbr: '',

        ocrb4: '',
        ocrb5: '',
        ocrb7: '',
        ocrb9: '',
        ocrb10: '',
      },

      dateMask: '##/##/####',

      countries: [],

      dialog: false,
      isGeneratingCS: false,

      a2User: false,

      isFetchingMtzCSdata: false,
    };
  },
  validations: {
    csData: {
      vehicle: {
        required,
      },
      plateNumber: {
        required,
      },
      registrationCountry: {
        required,
      },
      insCompAddress: {
        required,
      },
      insuranceCountry: {
        required,
      },
      contractNumber: {
        required,
      },
      insTaker: {
        required,
      },
      subscriberCountry: {
        required,
      },
    },
  },
  methods: {
    async generateCS() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.$notify({
          type: 'error',
          title: this.$t('errors.forms.errorFieldsNotificationTitle'),
          text: this.$t('errors.forms.errorFieldsNotificationContent'),
        });
        return;
      }

      this.isGeneratingCS = true;
      try {
        const doc = await this.$store.dispatch('fetchUserAccount');

        if (!doc.exists) {
          throw new Error('User doc does not exist.');
        }

        const csNbr = doc.data().csInAccount;
        if (csNbr <= 0) {
          throw new Error('ACCOUNT_EMPTY');
        }

        const userId = this.$store.state.userProfile.userId;
        let dataPayload = this.csData;
        if (!this.csData.subscriberPhone) {
          dataPayload.subscriberPhone = ' ';
        }
        dataPayload.createdOn = fb.fv.serverTimestamp();

        const ref = await fb.db
          .collection('allGeneratedCs')
          .doc(userId)
          .collection('cs')
          .add(dataPayload);

          dataPayload.userId = userId;
          // Logging
          await fb.db
          .collection('csGenerationLog')
          .add(dataPayload);  

        const csDocId = ref.id;
        const generateCS = fb.fnct.httpsCallable('generateCS');
        const result = await generateCS({
          csDocId: csDocId,
          lng: this.$i18n.locale,
        });

        window.open(
          result.data.downloadURL +
          '&response-content-disposition=attachment',
          '_blank',
          'location=yes,height=870,width=620,scrollbars=yes,status=yes'
        );
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        if (error.message === 'ACCOUNT_EMPTY') {
          this.dialog = true;
        } else {
          //TODO: treat here
        }
      } finally {
        this.isGeneratingCS = false;
      }
    },
    triggerBrowserDownload(url, fileName) {
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      link.setAttribute('target', 'new');
      document.body.appendChild(link);
      link.click();
    },
    goToOrder() {
      this.dialog = false;
      this.$router.push('account');
    },
  },
  computed: {
    userId() {
      return this.$store.state.currentUser.uid;
    },
    showDriverNameField() {
      if (this.userId === "pDCSMxOFKeWQuoBawOTx3TyGDt53") {
        return true;
      } else {
        return false;
      }
    },
    vehicleErrors() {
      const errors = [];
      if (!this.$v.csData.vehicle.$dirty) return errors;
      !this.$v.csData.vehicle.required &&
        errors.push(this.$t('errors.forms.mandatoryField'));
      return errors;
    },
    plateNumberErrors() {
      const errors = [];
      if (!this.$v.csData.plateNumber.$dirty) return errors;
      !this.$v.csData.plateNumber.required &&
        errors.push(this.$t('errors.forms.mandatoryField'));
      return errors;
    },
    registrationCountryErrors() {
      const errors = [];
      if (!this.$v.csData.registrationCountry.$dirty) return errors;
      !this.$v.csData.registrationCountry.required &&
        errors.push(this.$t('errors.forms.mandatoryField'));
      return errors;
    },
    insuranceNameAndAddressErrors() {
      const errors = [];
      if (!this.$v.csData.insCompAddress.$dirty) return errors;
      !this.$v.csData.insCompAddress.required &&
        errors.push(this.$t('errors.forms.mandatoryField'));
      return errors;
    },
    contractNumberErrors() {
      const errors = [];
      if (!this.$v.csData.contractNumber.$dirty) return errors;
      !this.$v.csData.contractNumber.required &&
        errors.push(this.$t('errors.forms.mandatoryField'));
      return errors;
    },
    insuranceCountryErrors() {
      const errors = [];
      if (!this.$v.csData.insuranceCountry.$dirty) return errors;
      !this.$v.csData.insuranceCountry.required &&
        errors.push(this.$t('errors.forms.mandatoryField'));
      return errors;
    },
    insTakerErrors() {
      const errors = [];
      if (!this.$v.csData.insTaker.$dirty) return errors;
      !this.$v.csData.insTaker.required &&
        errors.push(this.$t('errors.forms.mandatoryField'));
      return errors;
    },
    subscriberCountryErrors() {
      const errors = [];
      if (!this.$v.csData.subscriberCountry.$dirty) return errors;
      !this.$v.csData.subscriberCountry.required &&
        errors.push(this.$t('errors.forms.mandatoryField'));
      return errors;
    },
  },
  async created() {
    const idTokenResult = await fb.auth.currentUser.getIdTokenResult();
    const a2User = idTokenResult.claims.a2;
    if (a2User) {
      this.a2User = true;
    }

    const c = JSON.parse(JSON.stringify(this.$t('countries')));
    Object.keys(c).forEach((element) => this.countries.push(JSON.parse(JSON.stringify({ key: element, value: c[element] }))));

    this.$store.commit('updateCsCountries', this.countries);
    if (this.$route.query.dfmtz) {
      try {

        await new Promise((resolve) => setTimeout(resolve, 500));
        const userId = this.$store.state.currentUser.uid;

        this.isFetchingMtzCSdata = true;
        const docSnapshot = await fb.db
          .collection('csSentToMtz')
          .doc(userId)
          .collection('csSentToMtzByUser')
          .doc(this.$route.query.dfmtz)
          .get();

        const mtzExtractData = docSnapshot.data();

        this.csData.contractNumber =
          mtzExtractData.mtzExtractResponse.contractNumber;
        this.csData.vehicle = mtzExtractData.mtzExtractResponse.carMakeModel;
        this.csData.plateNumber = mtzExtractData.mtzExtractResponse.numberPlate;
        this.csData.insCompAddress =
          mtzExtractData.mtzExtractResponse.insuranceCompanyAddress;
        this.csData.insComp =
          mtzExtractData.mtzExtractResponse.insuranceCompanyName;
        this.csData.insTaker =
          mtzExtractData.mtzExtractResponse.insuranceTakerName +
          '\r\n' +
          mtzExtractData.mtzExtractResponse.insuranceTakerAddress;

        this.isFetchingMtzCSdata = false;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        if (error.message === 'ACCOUNT_EMPTY') {
          this.dialog = true;
          //TODO: treat here
        }
        this.isFetchingMtzCSdata = false;
      }
    } else {
      this.csData = this.$store.getters.getCsData;
      this.csData.propertyDamage = '1';

      if (this.csData.insComp === 'ASSU2000') {
        let tempString = '';
        if (this.csData.insTakerLine1.trim().length > 0) {
          tempString += this.csData.insTakerLine1.trim();
        }
        if (this.csData.insTakerLine2.trim().length > 0) {
          tempString += '\n' + this.csData.insTakerLine2.trim();
        }
        if (this.csData.insTakerLine3.trim().length > 0) {
          tempString += '\n' + this.csData.insTakerLine3.trim();
        }
        if (this.csData.insTakerLine4.trim().length > 0) {
          tempString += '\n' + this.csData.insTakerLine4.trim();
        }
        this.csData.insTaker = tempString;
      }

      let countryCode = 'be';
      if (
        this.csData.insComp === 'FOYER' ||
        this.csData.insComp === 'AXA_LU' ||
        this.csData.insComp === 'FOYER2' ||
        this.csData.insComp === 'BALOISE' ||
        this.csData.insComp === 'ALLIANZ_LU' ||
        this.csData.insComp === 'LUXEMBOURGEOISE'
      ) {
        countryCode = 'lu';
      } else if (
        this.csData.insComp === 'RISSOAN' ||
        this.csData.insComp === 'GENERALI_FR' ||
        this.csData.insComp === 'ALLIANZ_NOV' ||
        this.csData.insComp === 'AXA_FR' ||
        this.csData.insComp === 'FMA' ||
        this.csData.insComp === 'NOVELIA_NOV' ||
        this.csData.insComp === 'XENASSUR' ||
        this.csData.insComp === 'ZEPHIR_NOV' ||
        this.csData.insComp === 'APRIL' ||
        this.csData.insComp === 'ZEPHIR' ||
        this.csData.insComp === 'NOVELIA' ||
        this.csData.insComp === 'ALLIANZ_FR' ||
        this.csData.insComp === 'EQUITE' ||
        this.csData.insComp === 'ASSU2000'
      ) {
        countryCode = 'fr';
      }

      this.csData.registrationCountry = countryCode;
      this.csData.insuranceCountry = countryCode;
      this.csData.subscriberCountry = countryCode;
    }
  },
};
</script>

<style>
.title {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: bold;
}

.cs-option-digit {
  background-color: #ffffff;
  font-family: 'Roboto', sans-serif;
  font-size: 68px;
  font-style: normal;
  font-weight: 200;
  color: #9e9e9e;
}

.cs-option-title {
  font-family: 'Roboto', sans-serif;
  font-size: 21px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.2;
  width: 100%;
  color: #0d47a1;
}

.cs-option-text {
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.4;
  width: 100%;
}

.cs-field-title {
  font-size: 16px;
}
</style>
